import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';

export interface ISetSubscriptionSubjectParams extends ISingleIdParams {
  subject: string;
}

export class SetSubscriptionSubjectRequest extends Request<ISetSubscriptionSubjectParams, IEmptyResult> {
  constructor(id: string, subject: string) {
    super('setSubscriptionSubject', {
      id: id,
      subject: subject
    });
  }
}
